<div
  class="relative flex flex-col-reverse md:flex-row justify-between md:h-[18.125rem] pt-4 md:pt-0 transition-shadow duration-300 overflow-hidden rounded-lg"
  [class.hover:cursor-pointer]="ctaLink()"
  [class.hover:shadow-xl]="ctaLink()"
  (click)="ctaLink() && (isRedirectionExternal() ? openModal() : navigateToCtaLink())"
>
  <div class="flex flex-col gap-[1.5rem] p-6 w-full md:justify-between">
    <div class="flex flex-col justify-between md:max-w h-full overflow-auto">
      <div class="flex items-start justify-between">
        <div class="flex gap-4 items-center pb-[1.5rem]">
          @if(icon()){
          <icon [name]="icon()" [size]="'2.25rem'" class="flex-shrink-0"></icon>
          }
          <h3>{{title()}}</h3>
        </div>

        @if(!isFavoriteLoading() && id() && this.status() === "Approved") {
        <button
          class="ml-auto"
          type="button"
          [attr.aria-pressed]="isFavorite()"
          [attr.aria-label]="(isFavorite() ? 'components.tile.removeFromFavorites' : 'components.tile.addToFavorites') | transloco"
          [attr.title]="(isFavorite() ? 'components.tile.removeFromFavorites' : 'components.tile.addToFavorites') | transloco"
          (click)="$event.stopPropagation(); toggleFavorite()"
        >
          <icon
            [name]="isFavorite()? 'thumb-up-filled' : 'thumb-up'"
            [size]="'1.875rem'"
            aria-hidden="true"
            class="p-1 m-auto hover:bg-vinciGrey-200 hover:cursor-pointer rounded-lg mt-1 md:mt-2 transition-colors duration-300"
          ></icon>
          <span class="sr-only">
            {{ isFavorite() ? 'Retirer des favoris' : 'Ajouter aux favoris' }}
          </span>
        </button>
        }
      </div>
      @if(status()=="Pending"){
      <div
        class="flex gap-2 items-center px-3 py-2 bg-vinciGrey-200 text-black rounded-lg w-fit"
      >
        <icon [name]="'danger'" [size]="'1.25rem'"></icon>
        <p class="!text-[0.875rem] !font-bold">
          {{ 'components.tile.tileInPending' | transloco }}
        </p>
      </div>
      }
      <div class="flex flex-col gap-2">
        <p
          class="py-2 text-[0.875rem] md:max-w-[18.75rem] wysiwyg tile-text !font-light"
          [innerHTML]="text() | safeHtml"
        ></p>
      </div>
    </div>
    @if(ctaLink()){
    <app-button
      [text]="ctaText()"
      [variant]="buttonVariant()"
      [icon]="'arrow-right'"
      [iconSize]="'0.75rem'"
      (buttonClick)=" isRedirectionExternal() ? openModal() : navigateToCtaLink()"
      class="md:w-fit self-start"
    ></app-button>
    }
  </div>
  @if(image()){
  <img
    [src]="image()"
    class="h-[8.5rem] sm:w-[40%] sm:h-[18.125rem] object-contain sm:object-cover rounded-lg md:rounded-l-none self-center"
    [class.mobile-hidden]="!showImageOnMobile()"
    alt="tuile"
  />
  }
</div>

@if(isRedirectionExternal() && isModalOpen() ){
<app-modal
  [title]="'components.modal.title' | transloco"
  [buttonText]="'components.modal.ctaButtonText' | transloco"
  [text]="effectiveTextDisclaimer() ? effectiveTextDisclaimer() : 'components.modal.textDisclaimerDefault' | transloco"
  (closeModal)="closeModal()"
  (completeModal)="goToLink()"
  class="tile-modal"
></app-modal>
}
